<app-modal [isOpen]="isOpen" title="{{'web.ticketInspection' | translate }}" (close)="onClose()">
  @if (orderData; as orderData) {
    <div class="ticket-inspection">
      <div class="ticket-inspection__information">
        <div class="ticket-inspection__location">
          <span class="ticket-inspection__location-text">{{'web.webTicket' | translate }}</span>
        </div>
        <div class="ticket-inspection__field">
          <span class="ticket-inspection__label">{{'web.ticketValidFromLabel' | translate }}</span>
          <span class="ticket-inspection__value">
            {{ orderData.validFrom | danishTime | date:'dd.MM.yy, HH:mm:ss' }}
          </span>
        </div>
        <div class="ticket-inspection__field">
          <span class="ticket-inspection__label">{{'web.ticketNumberLabel' | translate }}</span>
          <span class="ticket-inspection__value">
            {{ orderData.ticketNumber }}
          </span>
        </div>
      </div>
      <div class="ticket-inspection__qr">
        @if (isTicketValid) {
          <app-aztec-code [base64Aztec]="orderData.base64Aztec"></app-aztec-code>
        }
      </div>
    </div>
  }
</app-modal>
